<script setup lang="ts">
import MenuHomeLogo from '../../Menu/MenuHomeLogo.vue'
import SidebarMenuDrawer from '../SidebarMenuDrawer.vue'
</script>

<template>
    <SidebarMenuDrawer
        position="static"
        :overlay="false"
        class="desktop-drawer"
        :open="true"
        showToggles>
        <MenuHomeLogo class="border-bottom home-item" />
        <template #footer-item>
            <slot />
        </template>
    </SidebarMenuDrawer>
</template>

<style scoped lang="scss">
.desktop-drawer {
    & .sidebar-content {
        width: 230px;
    }
}
.home-item {
    & :deep(.img) {
        height: 55px;
        width: auto;
    }
}
</style>
